<template>
  <page-template>
    <template #title>
      <div
        class="d-flex align-center justify-start pa-8"
      >
        <page-title
          title="Sugestões de transferência"
          back-to="conciliation.list"
        />
      </div>
    </template>
    <template #content>
      <v-row>
        <v-col cols="12">
          <v-container
            class="py-0"
            fluid
            grid-list-xl
          >
            <v-row>
              <form-group class="ma-0 pa-0">
                <v-row>
                  <v-col cols="12">
                    <v-card>
                      <v-card-actions class="pt-6 px-6">
                        <h3>Dados da transferência não conciliada automatica </h3>
                        <v-spacer />
                        <conciliation-action-btn
                          :label="'conciliar com outro cliente'"
                          :loading="loading"
                          color="primary"
                        />
                      </v-card-actions>
                      <v-card-text>
                        <form-group
                          class="ma-0 pa-0 mt-3"
                        >
                          <conciliation-data-content
                            v-model="conciliation"
                            :loading="loading"
                            autofill="Não retornado"
                            row
                          />
                        </form-group>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
                <v-row class="mt-6">
                  <v-col cols="12">
                    <v-card>
                      <v-card-title>
                        <h3 class="text-left">
                          Sugestões de destino da transferência:
                        </h3>
                      </v-card-title>
                      <v-card-text>
                        <suggestion-list
                          v-model="payload"
                          :loading="loading"
                        />
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </form-group>
            </v-row>
          </v-container>
        </v-col>
      </v-row>
    </template>
  </page-template>
</template>

<script>
import FormGroup from '@/app/arch/components/crud/components/FormGroup.vue';
import ClientRequest from '@/app/client/ClientRequest';
import RequestSelectMixin from '@/app/arch/mixins/RequestSelectMixin';
import LocalSessionMixin from '@/app/arch/mixins/LocalSessionMixin';
import PageTemplate from '@/app/arch/template/PageTemplate.vue';
import PageTitle from '@/app/arch/template/PageTitle.vue';
import ServiceMixin from '@/app/arch/mixins/ServiceMixin';
import ConciliationRequest from './ConciliationRequest';
import ConciliationDataContent from './components/ConciliationDataContent.vue';
import ConciliationActionBtn from './components/ConciliationActionBtn.vue';
import SuggestionList from './components/SuggestionList.vue';

const defaultItem = {
  bankAccount: {},
  pendingTransfers: [],
};

const faultSuggestion = {
  clientId: '',
  clientName: '',
  clientDocument: '',
  bankAccount: {
    id: '',
    bankName: '',
    bankCode: '',
    agency: '',
    accountNumber: '',
    accountVerificationDigit: '',
  },
  pendingTransfers: [
    {
      clientDocument: '',
      clientName: '',
      transferDate: '',
      value: '',
      bankName: '',
      agency: '',
      account: '',
      situation: '',
      id: '',
      createdAt: '',
      updatedAt: '',
      isActive: '',
    },
  ],
  checkedDocument: '',
  checkedAccountNumber: '',
  checkedBankCode: '',
  checkedAgency: '',
  id: '',
  createdAt: '',
  updatedAt: '',
  isActive: '',
};

export default {
  name: 'ConciliationEditPage',
  components: {
    FormGroup,
    ConciliationDataContent,
    ConciliationActionBtn,
    SuggestionList,
    PageTemplate,
    PageTitle,
  },
  mixins: [RequestSelectMixin, LocalSessionMixin, ServiceMixin],
  data: () => ({
    requestClass: ConciliationRequest,
    requestClients: ClientRequest,
    payload: [],
    loading: false,
    clients: [],
    clientMessageError: 'Falha os buscar clientes!',
    swalConfig: {
      errorMessage: 'Falha ao buscar lista de sugestões',
      showSuccessSwal: false,
    },
  }),
  computed: {
    proxyRequest() {
      return {
        get: () => this.requestClass.listSuggestions(
          this.getId,
        ),
      };
    },
    getId() {
      return this.$route.params.id;
    },
    conciliation() {
      const conciliation = this.getSessionItem('conciliationTransfer');
      return conciliation;
    },
    disabledSuggestion() {
      return (item) => {
        const suggestions = this.getSuggestionsPending(item);

        return (suggestions && suggestions.length) > 0;
      };
    },
    getSuggestionsPending() {
      return (item) => item.pendingTransfers
        .filter(
          ({ situation }) => situation === 'Pendente',
        );
    },
  },
  watch: {
    getId: {
      immediate: true,
      handler(id) {
        if (Number(id) >= 1) {
          this.getData();
        }
      },
    },
  },
  reactiveProvide: {
    name: 'clientOptions',
    include: ['clients'],
  },
  created() {
    this.getClients();
  },
  methods: {
    getData() {
      this.handleLoading();
      this.getSuggestionRequest();
    },
    handleLoading() {
      this.loading = !this.loading;
    },
    getSuggestionRequest() {
      this.callService(
        this.proxyRequest.get(),
        this.swalConfig,
        this.setObservationsData,
      );
    },
    setObservationsData(response) {
      this.handleLoading();
      if (this.hasData(response)) {
        this.payload = response.data.map(
          (item) => this.prepareSuggestionItem(item),
        );
      }
    },
    prepareSuggestionItem(item = {}) {
      const overrideItem = this.overrideNullProperties(item, faultSuggestion);
      return {
        ...overrideItem,
        bankAccount: this.overrideNullProperties(
          overrideItem.bankAccount,
          faultSuggestion.bankAccount,
        ),
        pendingTransfers: overrideItem.pendingTransfers.map(
          (transfer) => this.overrideNullProperties(
            transfer,
            faultSuggestion.pendingTransfers[0],
          ),
        ),
      };
    },
    listenReload() {
      this.$root.$on('reload-ted', (value) => {
        if (value) {
          this.reloadData();
        }
      });
    },
    reloadData() {
      if (this.$refs.form) {
        this.$refs.form.reloadEdit();
      }
    },

    getClients() {
      this.serviceCall(
        this.requestClients.list(
          this.makeParams(),
        ),
        this.setDataOptions('clients', 'nomCliente'),
        this.clientMessageError,
      );
    },
    prepareItems(item = defaultItem) {
      return {
        ...item,
        ...item.bankAccount,
      };
    },
    prepareTransferItems(item = defaultItem) {
      return item.pendingTransfers.map(
        (transfer) => ({
          ...transfer,
          item,
        }),
      );
    },
  },
};
</script>
